module.exports = __webpack_public_path__ + "media/images/lp_v6_check1-5c6f2598d9efc38f9ffda03fd535c011.webp";